import type { DocsExtensionType } from './docsExtensionType.js';
import type { AnyExtensionDef } from './generate-schema/types.js';
import { dashboardPage } from './dashboard-page/extension.js';
import { dashboardModal } from './dashboard-modal/extension.js';
import { dashboardPlugin } from './plugins/dashboard-plugin/extension.js';
import { dashboardMenuPlugin } from './plugins/dashboad-menu-plugin/extension.js';
import { event } from './event/extension.js';
import { servicePlugin } from './service-plugin/extension.js';
import { embeddedScript } from './embedded-script/extension.js';
import { customElement } from './custom-element/extension.js';
import { sitePlugin } from './site-plugin/extension.js';
import { dataCollection } from './data-collections/extension.js';
import { editorReactComponent } from './editor-react-component/extension.js';
import { contextProvider } from './context-provider/extension.js';
import { dashboardExternalPage } from './dashboard-external-page/extension.js';
import { appTools } from './app-tools/extension.js';

export const extensionHandlers = {
  DASHBOARD_PAGE: dashboardPage,
  DASHBOARD_MODAL: dashboardModal,
  DASHBOARD_PLUGIN: dashboardPlugin,
  DASHBOARD_MENU_PLUGIN: dashboardMenuPlugin,
  DASHBOARD_EXTERNAL_PAGE: dashboardExternalPage,
  EVENT: event,
  SERVICE_PLUGIN: servicePlugin,
  EMBEDDED_SCRIPT: embeddedScript,
  CUSTOM_ELEMENT: customElement,
  SITE_PLUGIN: sitePlugin,
  DATA_COLLECTION: dataCollection,
  EDITOR_REACT_COMPONENT: editorReactComponent,
  CONTEXT_PROVIDER: contextProvider,
  APP_TOOLS: appTools,
} satisfies Record<
  DocsExtensionType | 'CONTEXT_PROVIDER' | 'APP_TOOLS',
  AnyExtensionDef
>;

export type GenerateExtensionType = keyof typeof extensionHandlers;
